<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/waterCard/cardList')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <div class="pd-10 bg-white">
      <!-- 选择 -->
      <div class="topSelect">
        <div
          :class="selectActive === v.id ? 'selectActive' : 'select'"
          v-for="v in selectArr"
          :key="v.id"
          @click="selectActive = v.id"
        >
          {{ v.name }}
        </div>
      </div>

      <el-form ref="form" :rules="rules" :model="form" label-width="110px">
        <el-form-item label="水卡编号" prop="cardNo" v-if="selectActive == 1">
          <el-input
            v-model="form.cardNo"
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="起始卡号"
          prop="startCard"
          v-if="selectActive == 2"
        >
          <el-input
            v-model="form.startCard"
            placeholder="请输入起始卡号"
          ></el-input>
        </el-form-item>
        <el-form-item label="终止卡号" prop="endCard" v-if="selectActive == 2">
          <el-input
            v-model="form.endCard"
            placeholder="请输入终止卡号"
          ></el-input>
        </el-form-item> -->

        <div v-if="selectActive == 2">
          <div class="color409eff cursor mgt-30" @click="download">
            下载Excle示例
          </div>
          <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
          <el-upload
            ref="upload"
            :action="'#'"
            :limit="1"
            :multiple="false"
            :auto-upload="false"
            accept=".xls,.xlsx"
            :file-list="fileList"
            :http-request="uploadFile"
            :on-change="fileChange"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
          >
            <el-button size="small" type="primary" class="mgb-10"
              >文件浏览</el-button
            >
          </el-upload>
        </div>

        <el-form-item label="水卡管理员工" prop="people">
          <el-select
            filterable
            v-model="form.people"
            placeholder="请选择水卡管理员工"
          >
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-button class="mgl-50" type="primary" @click="sure('form')"
        >确定</el-button
      >
    </div>

    <!-- 分配结果-->
    <div class="table" v-if="oneTable.length > 0">
      <el-table :data="oneTable" border stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="cardId" label="卡号"> </el-table-column>
        <el-table-column prop="resultmsg" label="操作结果"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      selectArr: [
        { id: 1, name: "单卡分配" },
        { id: 2, name: "批量分配" },
      ],
      selectActive: 1,
      form: {
        cardNo: "",
        startCard: "",
        endCard: "",
        people: "",
      },
      userArr: [],
      rules: {
        cardNo: [
          { required: true, message: "请输入水卡编号", trigger: "blur" },
        ],
        startCard: [
          { required: true, message: "请输入起始卡号", trigger: "blur" },
        ],
        endCard: [
          { required: true, message: "请输入终止卡号", trigger: "blur" },
        ],
        people: [
          { required: true, message: "请选择水卡管理员工", trigger: "blur" },
        ],
      },
      fileList: [],
      oneTable: [],
    };
  },
  created() {
    this.getUserPull();
  },
  methods: {
    // 导表模板下载
    download() {
      this.$api.waterCard.template().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "分配模板.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.waterCard
        .moreFen({
          file: formData,
          userId: this.form.people,
        })
        .then((res) => {
          if (res.code === 200) {
            //   this.addVisible = false;
            // handleAlert("操作成功", "success");
            this.oneTable = res.data;
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },

    sure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认分配吗?", "info")
            .then(() => {
              if (this.selectActive === 1) {
                this.$api.waterCard
                  .fenPeople({
                    startId:
                      this.selectActive === 1
                        ? this.form.cardNo
                        : this.form.startCard,
                    endId:
                      this.selectActive === 1
                        ? this.form.cardNo
                        : this.form.endCard,
                    userId: this.form.people,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      // handleAlert("分配成功", "success");
                      this.oneTable = res.data;
                    }
                  });
              } else {
                this.$refs.upload.submit();
              }
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    getUserPull() {
      this.$api.waterCard.userPull().then((res) => {
        if (res.code === 200) {
          this.userArr = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topSelect {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .select {
    font-size: 16px;
    margin-right: 50px;
    text-decoration: underline;
    cursor: pointer;
  }

  .selectActive {
    font-size: 16px;
    margin-right: 50px;
    text-decoration: underline;
    color: var(--accent);
    cursor: pointer;
  }
}
.el-input,
.el-select {
  width: 30% !important;
}
</style>
